import React, { useState } from 'react'
import {Box, Button, FormControl, FormLabel, Grow, TextField} from "@mui/material";
import toast,{Toaster} from "react-hot-toast";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import BaseUrl from "../../../../Api/BaseUrl.js";
const HotelSignin = () => {
  let navigate = useNavigate();
  let [inputData,setInputData] = useState({
    hotelmail:"",
    hotelpassword:""
  })
  let inputHandler = (e)=>{
    let {name,value}= e.target;
    setInputData((prev)=>{
      return {
        ...prev,
        [name]:value
      }
    })
  }
  let submitHandler = async (e)=>{
    e.preventDefault();
  
    try {
      
      let response = await axios.post(`${BaseUrl}/hotels/authenticate`,inputData);
      let data = response.data;
      localStorage.setItem("hotelmail",data.hotel.hotelmail);
      localStorage.setItem("hotelid",data.hotel._id);
      navigate(`/hotel/home`);
     setTimeout(()=>{
      toast.success(data.message);
     },1000)
    } catch (error) {
      toast.error(error.response.data.message); 
    }
  }
  return (
    <Grow in>
    <Box bgcolor={"#D80032"} color={"white"} sx={{p:"5%",m:"100px 3%",borderRadius:"5px"}}>
        <form onSubmit={submitHandler}  >
            <FormControl  style={{color:"white"}} fullWidth >
                <FormLabel sx={{color:"white"}} htmlFor='hotelmail'>Enter the restaurant e-mail :</FormLabel>
                <TextField onChange={inputHandler} sx={{input:{color:"white"}}} variant='filled' type='email' id='hotelmail' name='hotelmail' required />
                <FormLabel sx={{color:"white"}} htmlFor='hotelpassword'>Enter the password :</FormLabel>
                <TextField onChange={inputHandler} sx={{input:{color:"white"}}} variant='filled' type='password' id='hotelpassword' name='hotelpassword' required />
                <Button type='submit' variant='contained' color='inherit' sx={{mt:"2%",backgroundColor:"#F78CA2",color:"black"}}>Submit</Button>
                <Toaster />
            </FormControl>
          
        </form>
    </Box>
    </Grow>
  )
}

export default HotelSignin